export const posts = [{
  'topic': 'NPS Survey Analysis',
  'filePath': '10-ways-to-enhance-customer-experience-using-nps-survey-analysis',
  'title': '10 Ways to Enhance Customer Experience Using NPS Survey Analysis',
  'excerpt': 'Dive deep into how NPS Survey Analysis can transform customer feedback into actionable insights, driving improved customer satisfaction and loyalty.',
  'imageUrl': require('C:/ELI/DEV/NPS_ANALYSIS_UI/src/assets/img/homepage/blog/t.png'),
  'imageDescription': 'Graph showing an upward trend in NPS scores.',
}, {
  'topic': 'Session Recording',
  'filePath': 'boosting-product-management-efficiency-with-advanced-session-recording',
  'title': 'Boosting Product Management Efficiency with Advanced Session Recording',
  'excerpt': 'Discover the power of advanced session recording in understanding user behavior and making data-driven product decisions.',
  'imageUrl': require('C:/ELI/DEV/NPS_ANALYSIS_UI/src/assets/img/homepage/blog/text=Session+Recording.png'),
  'imageDescription': 'Product manager reviewing user session recordings.',
}, {
  'topic': 'Product Roadmaps',
  'filePath': 'strategic-product-planning-aligning-roadmaps-to-customer-success',
  'title': 'Strategic Product Planning: Aligning Roadmaps to Customer Success',
  'excerpt': 'Learn how editable roadmaps with a feedback loop can align product teams with customer expectations, ensuring long-term success.',
  'imageUrl': require('C:/ELI/DEV/NPS_ANALYSIS_UI/src/assets/img/homepage/blog/text=Product+Roadmaps.png'),
  'imageDescription': 'Interactive roadmap with feedback and milestones.',
}, {
  'topic': 'Predictive Analytics',
  'filePath': 'reducing-churn-with-predictive-analytics-and-tailored-campaigns',
  'title': 'Reducing Churn with Predictive Analytics and Tailored Campaigns',
  'excerpt': 'Explore strategies to predict and prevent customer churn using comprehensive analytics and personalized outreach.',
  'imageUrl': require('C:/ELI/DEV/NPS_ANALYSIS_UI/src/assets/img/homepage/blog/text=Reduce+Churn.png'),
  'imageDescription': 'Charts displaying decreased churn rates after strategic interventions.',
}, {
  'topic': 'In-App Surveys',
  'filePath': 'the-ultimate-guide-to-building-an-effective-in-app-survey',
  'title': 'The Ultimate Guide to Building an Effective In-App Survey',
  'excerpt': 'From basic to advanced surveys, this guide covers best practices for gathering insightful user feedback without disrupting the user experience.',
  'imageUrl': require('C:/ELI/DEV/NPS_ANALYSIS_UI/src/assets/img/homepage/blog/text=In-App+Surveys.png'),
  'imageDescription': 'Mobile app screen showing a user engaging with a survey popup.',
}, {
  'topic': 'Cross-Team Collaboration',
  'filePath': 'cross-team-collaboration-breaking-silos-for-go-to-market-success',
  'title': 'Cross-Team Collaboration: Breaking Silos for Go-to-Market Success',
  'excerpt': 'Insights on fostering collaboration among product, marketing, and sales teams for a cohesive and successful product launch.',
  'imageUrl': require('C:/ELI/DEV/NPS_ANALYSIS_UI/src/assets/img/homepage/blog/text=Team+Collaboration.png'),
  'imageDescription': 'Illustration of different department symbols coming together around a table.',
}, {
  'topic': 'AI Insights',
  'filePath': 'leveraging-ai-for-deeper-customer-insights-and-product-innovation',
  'title': 'Leveraging AI for Deeper Customer Insights and Product Innovation',
  'excerpt': 'How AI-driven tools like customizable surveys with AI Writer can uncover deep insights and inspire innovative product features.',
  'imageUrl': require('C:/ELI/DEV/NPS_ANALYSIS_UI/src/assets/img/homepage/blog/text=AI+Insights.png'),
  'imageDescription': 'AI brain icon processing data and generating insights from surveys.',
}, {
  'topic': 'Personalized Onboarding',
  'filePath': 'enhance-user-adoption-with-personalized-onboarding-experiences',
  'title': 'Enhance User Adoption with Personalized Onboarding Experiences',
  'excerpt': 'Strategies for using customizable onboarding checklists and dynamic personalization to boost user adoption and engagement.',
  'imageUrl': require('C:/ELI/DEV/NPS_ANALYSIS_UI/src/assets/img/homepage/blog/text=User+Adoption.png'),
  'imageDescription': 'Step-by-step onboarding flow on a device screen.',
}, {
  'topic': 'Advanced Integration',
  'filePath': 'driving-operational-efficiency-with-advanced-integration-capabilities',
  'title': 'Driving Operational Efficiency with Advanced Integration Capabilities',
  'excerpt': 'A look into how enterprise-level integrations and automation can streamline operations and enhance product delivery.',
  'imageUrl': require('C:/ELI/DEV/NPS_ANALYSIS_UI/src/assets/img/homepage/blog/text=Operational+Efficiency.png'),
  'imageDescription': 'Flowchart representing various software integrations and automations.',
}];